<template>
  <div class="info-item" v-if="fields.length > 0">
    <div class="head">
      {{$ml.get(`Fields`)}}
      <SearchInput v-model="search"/>
    </div>
    <div class="list">
      <div class="headList">
        <div>
          {{$ml.get(`Field name`)}}
        </div>
        <div>
          {{$ml.get(`Farm name`)}}
        </div>
        <div>
          {{$ml.get(`Field area, ha`)}}
        </div>
      </div>
      <div v-for="item in true_data" :key="item.id">
        <div>
          <template v-if="item.name != null">
            {{item.name}}
          </template>
          <template v-else>
            -
          </template>
        </div>
        <div>
          <template v-if="item.farm_name != null">
            {{item.farm_name}}
          </template>
          <template v-else>
            -
          </template>
        </div>
        <div>
          <template v-if="item.area != null">
            {{item.area}}
          </template>
          <template v-else>
            -
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchInput from '@/components/common/SearchInput'

export default {
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      fields: 'subAccount/fields',
    }),
    true_data () {
      var res = [];

      this.fields.forEach(farm => {
        farm.fields.forEach(field => {
          field.farm_name = farm.name;
          res.push(field);
        });
      });

      if (this.search != '')
        res = res.filter(item => {
          if (item.name.indexOf(this.search) != -1 || item.farm_name.indexOf(this.search) != -1)
            return true;
          
          return false
        });

      return res;
    }
  },
  components: {
    SearchInput
  }
}
</script>

<style lang="scss" scoped>
  .info-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;

    .head {
      width: 100%;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 22px;
      color: #4C5056;
      padding-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 560px) {
        flex-direction: column;
        
        > div {
          margin-top: 20px;
        }
      }
    }

    .list {
      width: 100%;
      display: flex;
      flex-direction: column;

      > div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 0.7px solid #E4E5E6;
        padding: 0 30px;
        height: 66px;

        > div {
          width: 100%;
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          color: #4C5056;
          text-transform: capitalize;
        }

        &.headList {
          height: 33px;

          > div {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            letter-spacing: 0.05em;
            color: #8B8D91;
          }
        }
      }
    }
  }
</style>
